import React from 'react';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import {
  mergeClasses,
  makeStyles,
  shorthands,
  tokens,
} from '@fluentui/react-components';

const useCardTemplateStyles = makeStyles({
  cardLayout: {
    height: '100%',
    width: '100%',
    ...shorthands.overflow('hidden'),
    backgroundImage: 'radial-gradient(at 2.7% 92.9%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 100.2% 77.6%, hsl(200, 35%, 93%) 0px, transparent 50%),radial-gradient(at 1.3% 13.0%, #f0f3f5 0px, transparent 50%),radial-gradient(at 55.5% 13.8%, #fcf9f5 0px, transparent 50%),radial-gradient(at 55.7% 72.1%, #ffffff 0px, transparent 50%),radial-gradient(at 96.0% 12.2%, hsl(200, 35%, 93%) 0px, transparent 50%)',
    '& .ui-blocker-container': {
      ...shorthands.overflow('hidden'),
    },
  },
  mainContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    ...shorthands.overflow('auto'),
    ...shorthands.padding('100px', '0px'),
  },
  cardContainer: {
    backgroundColor: tokens.colorNeutralBackground1,
    width: '700px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...shorthands.padding('32px'),
    ...shorthands.gap('32px'),
  },
  'cardContainer-l': {
    width: '618px',
  },
  'cardContainer-m': {
    width: '424px',
  },
  'cardContainer-s': {
    width: '312px',
    ...shorthands.padding('16px'),
  },
  cardContentContainer: {
    minHeight: '280px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  tailContainer: {
    width: '100%',
  },
});

interface CardTemplateProps {
  items: {
    Blocker: React.FC;
    LoadingShimmer: React.FC;
    StepContainer: React.FC;
    CardFooter: React.FC;
    CardTail: React.FC;
    CancelDialog: React.FC;
    ConfirmDialog: React.FC;
  };
}

export const CardTemplate: React.FC<CardTemplateProps> = ({ items }) => {
  const {
    Blocker = React.Fragment,
    LoadingShimmer,
    StepContainer,
    CardFooter,
    CardTail,
    CancelDialog,
    ConfirmDialog,
  } = items;
  const classes = useCardTemplateStyles();
  const displayMode = useResponsiveSize();

  return (
    <div className={mergeClasses('card-layout', classes.cardLayout)}>
      <Blocker>
        <div className={mergeClasses('main-container', classes.mainContainer)}>
          <div className={mergeClasses('card-container', classes.cardContainer, classes[`cardContainer-${displayMode}`])}>
            <div className={mergeClasses('card-content-container', classes.cardContentContainer)}>
              {LoadingShimmer && <LoadingShimmer />}
              <StepContainer />
            </div>
            {CardFooter
              && (
              <div className={mergeClasses('footer-container', classes.footerContainer)}>
                <CardFooter />
              </div>
              )}
            {CardTail
              && (
              <div className={mergeClasses('tail-container', classes.tailContainer)}>
                <CardTail />
              </div>
              )}
          </div>
        </div>
      </Blocker>
      {CancelDialog && <CancelDialog />}
      {ConfirmDialog && <ConfirmDialog />}
    </div>
  );
};
